import styled from "styled-components";

export const ConfirmationContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 6px;
	font-size: 0.8rem;
	width: 100%;
	font-weight: normal;
	min-width: 550px;

	@media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
		min-width: unset;
	}
`;

export const ConfirmationMessage = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
	width: 100%;
	min-width: 0;
	font-weight: normal;
	overflow: hidden;

	@media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
		overflow-x: auto !important;
		overflow-y: hidden;
		white-space: nowrap !important;
		display: flex !important;
	}
`;

export const Label = styled.span`
	font-weight: normal;
	flex-shrink: 0;
	white-space: nowrap;
`;

export const Value = styled.span`
	font-weight: normal;
	flex: 0 1 auto;
	min-width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;

	@media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
		flex: 0 0 auto !important;
		overflow: visible !important;
		text-overflow: unset !important;
	}
`;

export const Separator = styled.span`
	flex-shrink: 0;
	color: #666;
	font-weight: normal;
`;

export const PartWrapper = styled.div`
	flex: 1;
	min-width: 0;
	width: 0;
	overflow: hidden;

	& .d-flex {
		display: block !important;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	@media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
		flex: 0 0 max-content !important;
		width: max-content !important;
		min-width: unset !important;
		overflow: visible !important;

		& .part-wrapper-ellipsis {
			overflow: visible !important;
			text-overflow: unset !important;
			white-space: nowrap !important;
			width: max-content !important;
		}

		& .d-flex {
			display: flex !important;
			overflow: visible !important;
			text-overflow: unset !important;
			white-space: nowrap !important;
			width: max-content !important;
		}
	}
`;

export const ConfirmationTitle = styled.div`
	font-weight: bold;
	font-size: 1rem;
`;
